import React, { useId, useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Collapse, Box } from "@mui/material";

const CustomSimpleAccordion = ({ title, content, defaultOpen = false }) => {
  const contentId = useId();
  const headerId = `${contentId}-header`;
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const handleToggle = () => {
    setIsOpen((currentIsOpen) => !currentIsOpen);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleToggle();
    }
  };

  return (
    <div
      className="qub-simple-accordion"
      style={{
        border: "1px solid #ccc",
        overflow: "hidden",
      }}
    >
      <div
        id={headerId}
        role="button"
        tabIndex={0}
        aria-expanded={isOpen}
        aria-controls={contentId}
        onClick={handleToggle}
        onKeyDown={handleKeyDown}
        style={{
          cursor: "pointer",
          padding: "10px 15px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
        }}
      >
        <div>{title}</div>
        <ExpandMoreIcon
          style={{
            transition: "transform 0.3s ease",
            transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
          }}
        />
      </div>
      <Collapse
        id={contentId}
        role="region"
        aria-labelledby={headerId}
        in={isOpen}
        timeout="auto"
      >
        <Box
          sx={{
            padding: "10px 15px",
            backgroundColor: "#fff",
          }}
        >
          {content}
        </Box>
      </Collapse>
    </div>
  );
};

export default CustomSimpleAccordion;
